import { render, staticRenderFns } from "./HeadingTextElement.vue?vue&type=template&id=518d1c1e&"
import script from "./HeadingTextElement.vue?vue&type=script&lang=ts&"
export * from "./HeadingTextElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports